<!-- OLD V4 VERSION -->
<div [formGroup]="getFormGroup()" [id]="getId()" class="form-group" [hidden]="getHidden()" *ngIf="getDragAndDrop() && this.getType() === InputFileTypeEnum.V4">
    <label class="control-label">{{getLabelValue()}}</label>
    <div id="divEditorInvoiceMain" class="uploadfilecontainer form-control" [class.col-sm-10]="!fullWidth" appDragDrop (onFileDropped)="uploadFile($event)">
        <div id="pr-attachContainer">
            <input hidden type="file" 
            [name]="getModelId()"
            [id]="'txt_' + getId()"
            #el
            [formControlName]="getModelId()"
            (change)="uploadFile($event.target.files)"
             [disabled]="getReadOnly()" 
             [multiple]="getMaxFiles() > 1" 
             [accept]="getFormats()">
            <div id="pr-textAttach">
                <strong>Arrastra un archivo</strong>
                <br> o bien presiona el siguiente botón.
                <br>
            </div>
            <div id="pr-btnAttach">
                <button id="pr-btnAddFile" (click)="el.click()" type="button" class="pr-btnAttachDetail" data-style="slide-up" [disabled]="getReadOnly()">
                    <span class="ladda-label">
                        <!-- <i class="fa fa-files-o fa-4" aria-hidden="true"></i>
                        <br> -->
                        <span id="pr-lblAddFile">Agregar Archivo</span>
                    </span>
                </button>
            </div>
        </div>
        <div>
            <div class="files-list" *ngFor="let file of files;let i= index">
                <p> {{ file.name }} </p>
                <button class="delete-file" (click)="deleteAttachment(i)">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Input old style compatibility -->
<div class="form-group" [id]="getId()" [hidden]="getHidden()" *ngIf="!getDragAndDrop() && this.getType() === InputFileTypeEnum.V4">
    <label class="col-sm-2 control-label">{{getLabelValue()}}</label>
    <div class="col-sm-10">
        <input type="file" #formControl (change)="uploadFile($event.target.files)" (click)="event2('onClick');onClick()" class="form-control" [accept]="getFormats()" [disabled]="getReadOnly()" style="position: absolute; clip: rect(0px 0px 0px 0px);">

        <div class="input-group">
            <input type="text" class="form-control" disabled [value]="files.length>0?files[0].name:''">
            <span class="input-group-btn" tabindex="0">
                <label (click)="formControl.click()" [for]="(getId())? getId(): 'in_file_ssvmn'"
                    class="btn btn-default " style="padding-top:2px;padding-bottom:2px;margin-left:5px">
                    <span class="fa fa-upload"></span> Buscar archivo
            </label>
            </span>
        </div>
    </div>
    <small class="help-block text-danger col-xs-12" [class.col-sm-10]="getOneLineControl()" [class.pull-right]="getOneLineControl()" *ngIf="!formControl.valid">{{getRequiredMessage()}}</small>
</div>


<!-- V5 VERSION -->
<!-- button -->
<label for="fileInput" 
       [formGroup]="getFormGroup()"
       [hidden]="getHidden()"
       class="file-upload-container bs-main-and-action d-flex align-items-center {{this.getClass()}}" 
       *ngIf="this.getType() === InputFileTypeEnum.Button && !this.getHidden()"
       [ngClass]="{
        'th-bg-confirmation th-text-white' : this.getWasValidated(),
        'th-bg-white th-text-main' : !this.getWasValidated()
        }">

    <span class="w-100 d-flex justify-content-center">
        {{this.getWasValidated() ? 'Archivo adjunto' : 'Elegir archivo'}}
    </span>
    <span class="separator"></span>
    <div class="d-flex justify-content-center align-items-center ms-auto">
        <i class="fa" aria-hidden="true" [ngClass]="{
            'fa-paperclip th-text-main': !this.getWasValidated(),
            'fa-trash-o th-text-white': this.getWasValidated()
        }">
        </i> 
    </div>
    <input type="file" 
           id="fileInput"
           #el
           [name]="getModelId()"
           [disabled]="getReadOnly()" 
           [formControlName]="getModelId()"
           [accept]="getFormats()"
           (change)="onButtonInputChange($event)" (click)="onButtonInputClick($event)"/>
</label>

<!-- card -->
<div class="card-input-file d-flex flex-column {{this.getClass()}}"
     [ngClass]="{
        'card-input-file-empty' : !this.getWasValidated(),
        'card-input-file-full' : this.getWasValidated()
     }"
     for="fileInput" 
     *ngIf="this.getType() === InputFileTypeEnum.Card && !this.getHidden()"
     [formGroup]="getFormGroup()"
     [hidden]="getHidden()">

    <div class="p-3 d-flex flex-column">
        <span class="bs-h3 pb-1 th-text-main">{{this.getTitle()}}</span>
        <span class="bs-paragraph th-text-gray-paragraphs">{{this.getDescription()}}</span>

        <!-- files context shown just after an user selects a file-->
        <div class="d-flex align-items-center pb-2 pt-1" *ngIf="this.getWasValidated()">
            <div class="card-file-tag">
              <i class="fa fa-check-circle ps-1 pe-1" aria-hidden="true"></i>
              <span class="pe-4 bs-paragraph th-text-gray-paragraphs">{{this.getFiles()[0].name}}</span>
            </div>
        </div>
    </div>

    <div class="h-separator"></div>

    <div class="d-flex flex-fill justify-content-center align-items-center">
        <label for="fileCardInput" class="file-card-button d-flex justify-content-center align-items-center">
            <i class="fa th-text-main" [ngClass]="{
                'fa-refresh' : this.getWasValidated(),
                'fa-paperclip' : !this.getWasValidated()
            }"></i>
            
            <span class="bs-h3 th-text-main">
                {{this.getWasValidated() ? 'Cambiar archivo' : 'Adjuntar'}}
            </span>

            <input type="file" 
                    id="fileCardInput"
                    class="file-card-input"
                    #el
                    [name]="getModelId()"
                    [disabled]="getReadOnly()" 
                    [formControlName]="getModelId()"
                    [accept]="getFormats()"
                    (change)="onButtonInputChange($event)" (click)="onButtonInputClick($event)"/>
        </label>
    </div>
</div>